import { useQuery } from "@tanstack/react-query";
import getScheduledReports from "api/scheduledReports/getScheduledReports";
import { scheduledReportsKey } from "queryKeys/scheduledReportsKey";

export default function useGetScheduledReportsQuery() {
  return useQuery({
    queryKey: scheduledReportsKey(),
    queryFn: getScheduledReports,
  });
}
